// extracted by mini-css-extract-plugin
export default {"root":"vXBlbg","line":"OgqJRW"};